import React, { useState } from "react";
import {
    faCircle,
    faComments,
    faHashtag,
    faHistory,
    faHome,
    faInfoCircle,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import moment from "moment";
import "moment/locale/pt-br";

import SpinnerComponent from "../../Loding/Spinner";

import "./styles.css";
import { IAtendimento } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { Link } from "react-router-dom";
import { ACESSOS } from "../../../Routes/Acessos";
import HTMLRemover from "../../Utils/HTMLRemover";
import ModalComponent from "../../Modais";
import CopyToClipboard from "../../Utils/CopyToClipboard";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import AtendimentosPorProdutoModal from "../AtendimentosPorProdutoModal";
import MenuAcoesDoCaso from "./MenuAcoesDoCaso";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import {
    VerificarInadimplenciaProdutoController,
    getInforVendasController,
} from "../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import { useUserInfor } from "../../../Context/User";
import { FormatterCPF } from "../../../Validations/InputMasks";
import { formatedTelefone } from "../../../Tools/FormatTools";

interface IInforCaso {
    Atendimento: IAtendimento;
    KPIsCard?: React.FC<any>;
}

export default function InforCaso(props: IInforCaso) {
    const [mostrarAtendimentosPorProduto, setMostrarAtendimentosPorProduto] =
        useState(false);
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;

    const { id } = useModuloInfo();
    const linkTelaCliente =
        useModuloInfo().DS_LINK_TELA_CLIENTE ??
        ACESSOS.GERAL.TELAS.CLIENTE.DS_LINK;

    const dsProdutoCompSeparado = props.Atendimento.DS_PRODUTO_COMP?.split("-");

    const empreendimento = props.Atendimento.DS_PRODUTO_COMP?.split("-")[0] ?? "";
    const divEmp = empreendimento;
    // const divProd =
    //     produto?.replace(/^\s|\s$/gm, "") !==
    //     empreendimento.replace(/^\s|\s$/gm, "")
    //         ? `${produto} - `
    //         : "";
    const divUnidade =
        dsProdutoCompSeparado && dsProdutoCompSeparado.length === 3
            ? dsProdutoCompSeparado[1] + '-' + dsProdutoCompSeparado[2]
            : props.Atendimento.DS_PRODUTO

    const emccampMode =
        ID_ORGANIZACAO === "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const { value: inadimplenciaProduto } = useAsyncEffect(() =>
        VerificarInadimplenciaProdutoController(props.Atendimento.ID_CASO)
    );

    const { value: lstInforVendas } = useAsyncEffect(() =>
        getInforVendasController(props.Atendimento.ID_CASO)
    );

    const umDiaEmMilissegundos = 1000 * 60 * 60 * 24;
    const dtSLA = new Date(props.Atendimento.DT_SLA || Date.now());
    const atendimentoClienteDtSLA = props.Atendimento.DT_FIM
        ? Math.round(
            (new Date(props.Atendimento.DT_FIM).getTime() - dtSLA.getTime()) /
            umDiaEmMilissegundos
        )
        : Math.round((Date.now() - dtSLA.getTime()) / umDiaEmMilissegundos);

    return props.Atendimento.ID_CASO > 0 ? (
        <>
            <div className="card card-custom w-auto gutter-b icon-background">
                {
                    <i
                        style={{
                            color:
                                props.Atendimento.HX_COR_PESO_ATENDIMENTO ||
                                "#B5B5C3",
                            zIndex: 0,
                        }}
                        className={`z-1 ${props.Atendimento.DS_ICON_PESO_ATENDIMENTO ||
                            "far fa-file-alt"
                            }`}
                    ></i>
                }

                <div className="card-header flex-wrap ribbon ribbon-top ribbon-ver ribbon">
                    <div className="ribbon-target-mult d-none d-sm-flex">
                        {ACESSOS.ATENDIMENTO.ID_MODULO === id && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        {atendimentoClienteDtSLA < 0 ? (
                                            <>
                                                {Math.abs(
                                                    atendimentoClienteDtSLA
                                                )}{" "}
                                                Dias para Vencer
                                            </>
                                        ) : (
                                            <>
                                                {atendimentoClienteDtSLA} Dias
                                                em Atraso SLA
                                            </>
                                        )}
                                    </Tooltip>
                                }
                            >
                                <div
                                    className={`text-${atendimentoClienteDtSLA < 0
                                        ? "success"
                                        : atendimentoClienteDtSLA === 0
                                            ? "warning"
                                            : "danger"
                                        }`}
                                    style={{ top: "-2px" }}
                                >
                                    <FontAwesomeIcon
                                        icon={faCircle}
                                        className={`text-${atendimentoClienteDtSLA < 0
                                            ? "success"
                                            : atendimentoClienteDtSLA === 0
                                                ? "warning"
                                                : "danger"
                                            } mt-3 mr-3`}
                                        size={"2x"}
                                    />
                                </div>
                            </OverlayTrigger>
                        )}
                        {props.Atendimento.DS_OCORRENCIA &&
                            emccampMode &&
                            ACESSOS.ASSISTENCIA.ID_MODULO === id ? (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        Ocorrência
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="ribbon-target ribbonCustom bg-primary"
                                    style={{ top: "-2px" }}
                                >
                                    {props.Atendimento.DS_OCORRENCIA}
                                </div>
                            </OverlayTrigger>
                        ) : null}
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    ID Atendimento / Caso
                                </Tooltip>
                            }
                        >
                            <div
                                className="ribbon-target ribbonCustom bg-warning"
                                style={{ top: "-2px" }}
                            >
                                {props.Atendimento.ID_CASO}
                            </div>
                        </OverlayTrigger>

                        {props.Atendimento.DS_OBSERVACAO &&
                            props.Atendimento.DS_OBSERVACAO !== null ? (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        ID Atendimento / Caso
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="ribbon-target ribbonCustom bg-dark"
                                    style={{ top: "-2px" }}
                                >
                                    {props.Atendimento.DS_OBSERVACAO}
                                </div>
                            </OverlayTrigger>
                        ) : null}

                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    Canal de Atendimento
                                </Tooltip>
                            }
                        >
                            <div
                                className="ribbon-target ribbonCustom bg-info"
                                style={{ top: "-2px" }}
                            >
                                <FontAwesomeIcon
                                    icon={faComments}
                                    className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                />
                                {props.Atendimento.DS_TIPO_CANAL_ATENDIMENTO}
                            </div>
                        </OverlayTrigger>
                        {(props.Atendimento.DS_ATENDENTE ||
                            props.Atendimento.DS_USUARIO_RESPONSAVEL) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            Atendente
                                        </Tooltip>
                                    }
                                >
                                    <div
                                        className="ribbon-target ribbonCustom bg-success"
                                        style={{ top: "-2px" }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faUser}
                                            className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                        />
                                        {props.Atendimento.DS_ATENDENTE ||
                                            props.Atendimento
                                                .DS_USUARIO_RESPONSAVEL}
                                    </div>
                                </OverlayTrigger>
                            )}
                        <MenuAcoesDoCaso />
                    </div>
                    <div
                        style={{ right: "10px", top: "10px" }}
                        className="d-flex align-items-center g-2  position-absolute d-sm-none"
                    >
                        <OverlayTrigger
                            overlay={
                                <Tooltip
                                    id="tooltip-disabled"
                                    className="d-flex flex-column"
                                >
                                    <div className="d-flex flex-column font-size font-weight-bold">
                                        <div>
                                            <FontAwesomeIcon
                                                icon={faUser}
                                                className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                            />
                                            {props.Atendimento.DS_ATENDENTE ||
                                                props.Atendimento
                                                    .DS_USUARIO_RESPONSAVEL}
                                        </div>
                                        <div>
                                            <FontAwesomeIcon
                                                icon={faComments}
                                                className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                            />
                                            {
                                                props.Atendimento
                                                    .DS_TIPO_CANAL_ATENDIMENTO
                                            }
                                        </div>
                                        <div>
                                            <FontAwesomeIcon
                                                icon={faHashtag}
                                                className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                            />
                                            {props.Atendimento.ID_CASO}
                                        </div>
                                    </div>
                                </Tooltip>
                            }
                        >
                            <div className="d-flex text-primary">
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    size="2x"
                                    className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                />
                            </div>
                        </OverlayTrigger>
                        <MenuAcoesDoCaso />
                    </div>

                    <div className="card-title">
                        <div className="d-flex flex-column flex-wrap align-items-start">
                            <div className="d-flex flex-column align-items-start justify-content-center flex-wrap text-break">
                                <div className="d-flex align-items-end justify-content-center flex-wrap text-break">
                                    {props.Atendimento
                                        .DS_ICON_PESO_ATENDIMENTO && (
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip
                                                        id="tooltip-disabled"
                                                        className="m-0 p-0"
                                                    >
                                                        <label
                                                            className="m-0 p-0"
                                                            style={{
                                                                color:
                                                                    props
                                                                        .Atendimento
                                                                        .HX_COR_PESO_ATENDIMENTO ||
                                                                    "#B5B5C3",
                                                            }}
                                                        >
                                                            {" "}
                                                            {
                                                                props.Atendimento
                                                                    .DS_TIPO_PESO_ATENDIMENTO
                                                            }
                                                        </label>
                                                    </Tooltip>
                                                }
                                            >
                                                <i
                                                    style={{
                                                        color:
                                                            props.Atendimento
                                                                .HX_COR_PESO_ATENDIMENTO ||
                                                            "#B5B5C3",
                                                    }}
                                                    className={`mr-3 mb-2 mt-2 icon-xl ${props.Atendimento.DS_ICON_PESO_ATENDIMENTO}`}
                                                ></i>
                                            </OverlayTrigger>
                                        )}
                                    {props.Atendimento.DS_CONTATO !==
                                        props.Atendimento.DS_CONTA && (
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip id="tooltip-disabled-contato">
                                                        Contato
                                                    </Tooltip>
                                                }
                                            >
                                                <div className="d-flex align-items-center text-muted mr-3">
                                                    {props.Atendimento.DS_CONTATO}
                                                </div>
                                            </OverlayTrigger>
                                        )}
                                </div>
                                <span className="font-size-h3 font-weight-bold">
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="tooltip-disabled-cliente">
                                                Cliente
                                            </Tooltip>
                                        }
                                    >
                                        <Link
                                            to={linkTelaCliente(
                                                props.Atendimento.ID_CONTA
                                            )}
                                            className="text-dark text-hover-primary font-size-h3 mr-2"
                                        >
                                            {props.Atendimento.DS_CONTA}
                                        </Link>
                                    </OverlayTrigger>

                                    <CopyToClipboard>
                                        {props.Atendimento.DS_CONTA}
                                    </CopyToClipboard>
                                </span>
                            </div>
                            {props.Atendimento.NR_CPF && (
                                <span className="label font-size-normal font-weight-bolder label-light-info label-inline mr-2 my-1 h-auto">
                                    CPF {props.Atendimento.NR_CPF}
                                </span>
                            )}
                            {props.Atendimento.DS_EMAIL && (
                                <span className="label font-size-normal font-weight-bolder label-light-success label-inline mr-2 my-1 h-auto">
                                    {props.Atendimento.DS_EMAIL}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="card-body p-4" style={{ zIndex: 5 }}>
                    <div className="d-flex">
                        <div className="flex-grow-1">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                                <div className="d-flex flex-wrap flex-column align-items-center ">
                                    <div className="mr-3">
                                        <div className="font-weight-bold text-center">
                                            Data Inicial
                                        </div>
                                        <span className="label label-lg label-light-success label-inline text-uppercase font-weight-bold">
                                            {moment(
                                                props.Atendimento.DT_INICIO
                                            ).format("lll")}
                                        </span>
                                    </div>
                                    {props.Atendimento.DT_FIM && (
                                        <div className="mt-1 mr-3">
                                            <div className="font-weight-bold text-center">
                                                Data Final
                                            </div>
                                            <span className="label label-lg label-light-danger label-inline text-uppercase font-weight-bold">
                                                {moment(
                                                    props.Atendimento.DT_FIM
                                                ).format("lll")}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <div className="d-flex flex-column w-75">
                                    {props.Atendimento.DS_CASO && (
                                        <div className="text-break flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5 ml-5">
                                            <HTMLRemover>
                                                {props.Atendimento.DS_CASO}
                                            </HTMLRemover>
                                        </div>
                                    )}
                                    {props.Atendimento
                                        .DS_MOTIVO_CANCELAMENTO && (
                                            <div className="flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5 ml-5">
                                                <p>
                                                    <span className="font-weight-bolder">
                                                        Cancelado:
                                                    </span>{" "}
                                                    {
                                                        props.Atendimento
                                                            .DS_MOTIVO_CANCELAMENTO
                                                    }
                                                </p>
                                            </div>
                                        )}
                                </div>

                                <div className="pl-3 d-flex flex-wrap align-items-center justify-content-center my-2 mt-5">
                                    <div className="d-flex flex-nowrap align-items-center justify-content-center">
                                        <div
                                            className={`symbol symbol-45 ${inadimplenciaProduto
                                                ? "symbol-light-danger"
                                                : "symbol-light-success"
                                                }`}
                                        >
                                            <div className="symbol-label">
                                                <FontAwesomeIcon
                                                    icon={faHome}
                                                    size="lg"
                                                />
                                            </div>
                                        </div>
                                        <div className="text-left ml-2">
                                            {props.Atendimento?.NR_SPE_CNPJ ? (
                                                <OverlayTrigger
                                                    overlay={
                                                        <Tooltip
                                                            id={`cnpjEmpreendimento`}
                                                        >
                                                            <div>
                                                                Escritório de
                                                                Cobrança:{" "}
                                                                {props
                                                                    .Atendimento
                                                                    ?.DS_BONIFICACAO
                                                                    ? props
                                                                        .Atendimento
                                                                        ?.DS_BONIFICACAO
                                                                    : "Sem Informação"}
                                                            </div>
                                                            <div>
                                                                CNPJ do
                                                                Empreendimento:{" "}
                                                                {FormatterCPF(
                                                                    props
                                                                        .Atendimento
                                                                        ?.NR_SPE_CNPJ ??
                                                                    0
                                                                )}
                                                            </div>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div className="font-size-h6 text-dark-75 font-weight-bolder">
                                                        {divEmp}
                                                        <FontAwesomeIcon
                                                            title="Histórico"
                                                            cursor={"pointer"}
                                                            onClick={() =>
                                                                setMostrarAtendimentosPorProduto(
                                                                    true
                                                                )
                                                            }
                                                            icon={faHistory}
                                                            size="lg"
                                                        />
                                                    </div>
                                                </OverlayTrigger>
                                            ) : (
                                                <div className="font-size-h6 text-dark-75 font-weight-bolder">
                                                    {divEmp}
                                                    <FontAwesomeIcon
                                                        title="Histórico"
                                                        cursor={"pointer"}
                                                        onClick={() =>
                                                            setMostrarAtendimentosPorProduto(
                                                                true
                                                            )
                                                        }
                                                        icon={faHistory}
                                                        size="lg"
                                                    />
                                                </div>
                                            )}

                                            <div className="font-size-sm font-weight-bold mt-1">
                                                {divUnidade}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="row d-flex justify-content-center align-items-center">
                                <div className="col-md-6">
                                    <div className="d-flex flex-column w-75 d-flex justify-content-center align-items-center">
                                        {lstInforVendas?.CONTA.NR_TELEFONE && (
                                            <div className="flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5 ml-5">
                                                <span className="font-weight-bolder">
                                                    Telefone:
                                                </span>
                                                {formatedTelefone(
                                                    lstInforVendas?.CONTA
                                                        .NR_TELEFONE
                                                )}
                                            </div>
                                        )}
                                        {lstInforVendas?.CONTA.DS_EMAIL && (
                                            <div className="flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5 ml-5">
                                                <p>
                                                    <span className="font-weight-bolder">
                                                        Email:
                                                    </span>{" "}
                                                    {
                                                        lstInforVendas?.CONTA
                                                            .DS_EMAIL
                                                    }
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="d-flex flex-column w-75 d-flex justify-content-center align-items-center">
                                        {lstInforVendas?.INTERESSE
                                            ?.DS_UN_INTERESSE && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5 ml-5">
                                                    <p>
                                                        <span className="font-weight-bolder">
                                                            Unidade de Interesse:{" "}
                                                        </span>
                                                        {
                                                            lstInforVendas
                                                                ?.INTERESSE
                                                                ?.DS_UN_INTERESSE
                                                        }
                                                    </p>
                                                </div>
                                            )}
                                        {lstInforVendas?.ORIGEM
                                            ?.DS_ORIGEM_LEAD && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5 ml-5">
                                                    <span className="font-weight-bolder">
                                                        Mídia de Origem:{" "}
                                                    </span>
                                                    {
                                                        lstInforVendas?.ORIGEM
                                                            .DS_ORIGEM_LEAD
                                                    }
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {props.KPIsCard && (
                    <div className="card-footer d-flex justify-content-between pt-3 pb-3 pr-5">
                        <props.KPIsCard />
                    </div>
                )}
            </div>

            <ModalComponent
                setShow={setMostrarAtendimentosPorProduto}
                show={mostrarAtendimentosPorProduto}
                ModalComponent={{
                    size: "xl",
                    Component: () => (
                        <AtendimentosPorProdutoModal
                            idProduto={props.Atendimento.ID_PRODUTO}
                        />
                    ),
                    headerComponent: "Atendimentos por Produto",
                }}
            />
        </>
    ) : (
        <SpinnerComponent />
    );
}
